import React, { useState, useEffect } from 'react';
import ContactServices from '../services/ContactServices';
import useAsync from '../hooks/useAsync';

function Refer() {
  const { data, error, isLoading } = useAsync(ContactServices.getRefer);


  console.log("Data:", data);


  const [formValues, setFormValues] = useState({
    point: '',
    usePoint: '',
    work: [''],
    status: false,
  });

  useEffect(() => {
    if (data?.data) {
      setFormValues({
        point: data.data.point || '',
        usePoint: data.data.usePoint || '',
        work: data.data.work || [],
        status: data.data.status || false,
      });
    }
  }, [data]);

  const handleWorkChange = (index, event) => {
    const updatedWork = formValues.work.map((work, i) =>
      i === index ? event.target.value : work
    );
    setFormValues({
      ...formValues,
      work: updatedWork,
    });
  };

  const addWork = () => {
    setFormValues({
      ...formValues,
      work: [...formValues.work, ''],
    });
  };

  const removeWork = (index) => {
    const updatedWork = formValues.work.filter((_, i) => i !== index);
    setFormValues({
      ...formValues,
      work: updatedWork,
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const toggleStatus = () => {
    setFormValues((prevValues) => ({
      ...prevValues,
      status: !prevValues.status,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await ContactServices.updateRefer(data.data._id, formValues);
      alert('Refer & Earn details updated successfully');
    } catch (error) {
      console.error('Failed to update Refer & Earn details', error);
      alert('Failed to update Refer & Earn details');
    }
  };

  if (isLoading) {
    return <div className="loader design_loading">Loading...</div>;
  }

  if (error) {
    return <div>Error loading Refer & Earn details</div>;
  }

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
      
                <div className="my-auto">
      
                  <h5 className="page-title fs-21 mb-1">
                  Refer & Earn 
                  </h5>
                  <nav>
      
                    <ol className="breadcrumb mb-0">
      
                      <li className="breadcrumb-item">
                        <a href="javascript:void(0);">Home</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                      Refer & Earn
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                
                  <div className="pe-1 mb-xl-0">
      
      
                  </div>
      
      
      
                </div>
              </div>
 
      <div className="container-box">
        <div className="container-box-inner table-reponsive-tabe">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Refer Point</label>
                    <input
                      type="number"
                      name="point"
                      className="form-control"
                      value={formValues.point}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Use Order Amount(%)</label>
                    <input
                      type="number"
                      name="usePoint"
                      className="form-control"
                      value={formValues.usePoint}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="row">
                      {formValues.work.map((work, index) => (
                  <div className="col-lg-6">
                    <div className="input-field">
                      <label>How It Works</label>
                        <div key={index} className="input-group mb-2">
                          <input
                            type="text"
                            className="form-control"
                            value={work}
                            onChange={(event) => handleWorkChange(index, event)}
                            placeholder="Work description"
                            required
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => removeWork(index)}
                            >
                              &times;
                            </button>
                          </div>
                        </div>
                    </div>
                    </div>
                      ))}

                    <div className="col-sm-6">
                    <div className="input-field align-items-center gap-2">
    <label className="mb-0">Refer Active/Inactive</label>
    <label className="toggle-switch mt-3">
      <input
        type="checkbox"
        name="status"
        checked={formValues.status === "active"}
        onChange={(event) =>
          setFormValues((prevState) => ({
            ...prevState,
            status: event.target.checked ? "active" : "inactive",
          }))
        }
      />
      <span className="slider round"></span>
    </label>
  </div>
                    </div>
                  </div>
                </div>

              </div>
                <div className='d-flex justify-content-between'> 
                <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={addWork}
                    >
                      + Add Work
                    </button>
              <button type="submit" className="submit-green-btn">SUBMIT</button>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Refer;
